<template>
	<div>
		<div class="row">
			<div class="col-md-6 col-md-offset-3">
				<div class="panel panel-default">
					<div class="panel-heading panel-dark text-center">
						<b>PayPal Test</b>
					</div>
					
					<div class="panel-body">


<form class="w3-container w3-display-middle w3-card-4 " method="POST" id="payment-form"  action="http://api.filedsafely.local/api/paypal/payment">
	<h2 class="w3-text-blue">Payment Form</h2>
	<p>Demo PayPal form</p>
	<p>      
		<label class="w3-text-blue"><b>Enter Amount</b></label>
		<input class="w3-input w3-border" name="amount" type="text">
	</p>      
	<button class="w3-btn w3-blue">Pay with PayPal</button>
</form>


					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>

export default {
	name: 'pptest',

	props: {
	},
	
	data() {
		return {
			api_token: '',
		};
	},

	computed: {
		is_logged_in() {
			var status     = false;
			this.api_token = localStorage.getItem('api_token');
			
			if (this.api_token  &&  this.api_token.length == 64) {
				status = true;
			}
	
				
			return status;
		},

		user() {
			return this.$store.getters.USER;
		}
	},
	
	created() {
	},

	mounted() {
	},

	destroyed() {
	},

	methods: {
	},
	
	/*
	beforeRouteLeave(to, from, next) {
		// do something
		next();
	}
	*/
}

</script>
